var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "m-fast-payment-system-bank", attrs: { href: _vm.bankUrl } },
    [
      _c("img", {
        staticClass: "m-fast-payment-system-bank__logo",
        attrs: { src: _vm.bank.logoURL, alt: _vm.bank.bankName }
      }),
      _c("span", [_vm._v(_vm._s(_vm.bank.bankName))]),
      _c("f-sprite-icon", {
        staticClass: "m-fast-payment-system-bank__arrow",
        attrs: { "icon-link": _vm.$options.icons.IconArrow.id }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }